import { React, useState, useEffect } from 'react'
import { motion } from "framer-motion";
import { Helmet } from 'react-helmet'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight, faBuilding, faEnvelopesBulk, faArrowRight, faCalendarDays, faUsers, faTriangleExclamation, faPlus } from '@fortawesome/free-solid-svg-icons'

import MainHeader from '../../../components/MainHeader/MainHeader.js'
import MainFooter from '../../../components/MainFooter/MainFooter.js'
import Skeleton from '../../../components/Skeleton/Skeleton.js'
import AdminGuard from '../../../components/AdminGuard/AdminGuard.js'

import { lP, boxvar2_1, boxvar2_2, boxvar4, URL_MAINAPI, API_TOKEN } from '../../../main.js'

import '../../../main.css'
import './AdminOverview.css'
import './MAdminOverview.css'

import Cookies from 'universal-cookie'

export default function AdminOverview() {

    var [orgData, setOrgData] = useState([])
    // 0 = lädt, 1 = geladen, -1 = Fehler
    var [loadedOrgData, setLoadedOrgData] = useState(0)
    var [search, setSearch] = useState("")

    const cookies = new Cookies()
    let cur_authtoken = cookies.get('authtoken')

    useEffect(() => {
        getAllOrgs()
    }, [])

    function getAllOrgs() {
        try {
            setLoadedOrgData(0)
            fetch(URL_MAINAPI + "/organization/all", {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },
            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                if (res.status === 200 && Array.isArray(res.data.data)) {
                    setOrgData(res.data.data)
                    setLoadedOrgData(1)
                } else {
                    setOrgData([])
                    setLoadedOrgData(-1)
                }
            }))
        } catch (err) {
            setOrgData([])
            setLoadedOrgData(-1)
        }
    }

    const searchTerm = search.trim().toLowerCase()
    const filteredOrgs = searchTerm
        ? orgData.filter((org) => (org.name + ' ' + (org.contact ? org.contact.email : '') + ' ' + org._id).toLowerCase().includes(searchTerm))
        : orgData

    return (
        <div className='mainCon page' id='mainCon'>
            <MainHeader selectedsite={""} />
            <Helmet>
                <meta charSet="utf-8" />
                <title>Helferzeit-Admin</title>
                <meta name="robots" content="noindex" />
            </Helmet>

            <main className='page-body container section' style={{ paddingTop: '36px' }}>
                <div className='breadcrumb'>
                    <a href='/profil'>Profil</a>
                    <FontAwesomeIcon icon={faChevronRight} />
                    <span>Helferzeit-Administration</span>
                </div>

                <div className='section-eyebrow'>Interne Verwaltung</div>
                <motion.h1
                    variants={boxvar4}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, margin: "-50px" }}
                    className='section-title'
                    style={{ marginBottom: '6px' }}
                >
                    Admin-Übersicht
                </motion.h1>
                <p className='section-sub'>Alle Organisationen und Events verwalten, neue Organisationen anlegen und Plattform-Rundmails versenden.</p>

                <AdminGuard>
                    <motion.div variants={boxvar2_1} initial="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                        <div className='grid grid-2 adminov-actions'>
                            <div className='card adminov-action'>
                                <span className='adminov-icon'><FontAwesomeIcon icon={faBuilding} /></span>
                                <div>
                                    <h3>Organisation erstellen</h3>
                                    <p>Neue Organisation anlegen und optional direkt einen ersten Manager zuweisen.</p>
                                </div>
                                <a href='/admin/org/new' className='btn btn-primary btn-sm'>
                                    <FontAwesomeIcon icon={faPlus} /> Neue Organisation
                                </a>
                            </div>
                            <div className='card adminov-action'>
                                <span className='adminov-icon'><FontAwesomeIcon icon={faEnvelopesBulk} /></span>
                                <div>
                                    <h3>Plattform-Rundmail</h3>
                                    <p>Nachricht an alle Newsletter-Abonnenten oder – für wichtige Service-Infos – an alle User.</p>
                                </div>
                                <a href='/admin/mailing' className='btn btn-primary btn-sm'>
                                    Zur Rundmail <FontAwesomeIcon icon={faArrowRight} />
                                </a>
                            </div>
                        </div>
                    </motion.div>

                    <motion.div className='section-gap' variants={boxvar2_2} initial="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                        <h2 className='adminov-title'>
                            Alle Organisationen
                            {orgData.length > 0 ? <span className='badge badge-accent' style={{ marginLeft: '8px' }}>{orgData.length}</span> : null}
                        </h2>
                        <p className='adminov-hint'>Als Admin hast du in jeder Organisation und jedem Event dieselben Rechte wie ein Manager. Inaktive Organisationen lassen sich nur direkt in der Datenbank reaktivieren.</p>

                        <div className="field adminov-search">
                            <input type="search" placeholder="Nach Name, E-Mail oder ID filtern" value={search} onInput={(e) => setSearch(e.target.value)} aria-label="Organisationen filtern"></input>
                        </div>

                        {(loadedOrgData === 0) ? <Skeleton variant="grid" cols={3} count={3} /> : null}
                        {(loadedOrgData === -1) ? <p className='adminov-empty'>Organisationen konnten nicht geladen werden.</p> : null}
                        {(loadedOrgData === 1 && filteredOrgs.length === 0) ? <p className='adminov-empty'>Keine Organisation gefunden.</p> : null}

                        <div className='grid grid-3' style={{ marginTop: '14px' }}>
                            {filteredOrgs.map(function (org) {
                                const isActive = org.active == 1
                                return (
                                    <div
                                        key={org._id}
                                        className={"card adminov-org noselect" + (isActive ? " card-hover" : " adminov-org-inactive")}
                                        onClick={() => { if (isActive) lP('/manage/org/' + org._id) }}
                                        role={isActive ? "button" : undefined}
                                        tabIndex={isActive ? 0 : undefined}
                                        onKeyDown={(e) => { if (isActive && e.key === 'Enter') lP('/manage/org/' + org._id) }}
                                    >
                                        <div className='adminov-org-top'>
                                            <h3>{org.name}</h3>
                                            {isActive ? (
                                                <span className='badge badge-open'>aktiv</span>
                                            ) : (
                                                <span className='badge badge-error'><FontAwesomeIcon icon={faTriangleExclamation} /> inaktiv</span>
                                            )}
                                        </div>
                                        <span className='adminov-org-meta'>
                                            <FontAwesomeIcon icon={faCalendarDays} /> {org.eventCount} {org.eventCount === 1 ? 'Event' : 'Events'}
                                            {' · '}
                                            <FontAwesomeIcon icon={faUsers} /> {org.managerCount} Manager
                                        </span>
                                        {(org.contact && org.contact.email) ? <span className='adminov-org-meta'>{org.contact.email}</span> : null}
                                        {isActive ? (
                                            <a href={'/manage/org/' + org._id} className='btn btn-primary btn-sm'>
                                                Verwalten <FontAwesomeIcon icon={faArrowRight} />
                                            </a>
                                        ) : null}
                                    </div>
                                )
                            })}
                        </div>
                    </motion.div>
                </AdminGuard>
            </main>

            <MainFooter useEventStyle={false} />
        </div>
    )
}
